import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-coalridge.webp"
            alt="Coalridge"
          />
        </p>
        <strong>
          The remnants of Doskvol’s original hilltop mining settlement, now home
          to laborers and industrial factories.
        </strong>{" "}
        <em>
          Coalridge is home to most of the{" "}
          <strong>machinists, industrial laborers, and factories</strong> of the
          city. It’s <strong>cramped, soot-choked, and loud</strong>
          —spewing dense clouds of black <strong>smoke</strong>, showers of{" "}
          <strong>sparks</strong>, and burning <strong>cinders</strong>. The old{" "}
          <strong>elevated train lines</strong> that once hauled coal now carry
          heavy equipment and raw materials to and from Gaddoc Station, though
          many of the ancient tracks and cars have been abandoned to squatters
          who’ve converted them into makeshift homes.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-coalridge.webp"
          alt="Coalridge"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Nutshell.</strong> Mine, Ironworks, Brickston (lots of
                gangs), laborers and factories.
                <br />
                <strong>Scene:</strong> Soot-covered workers hacking up black
                bile as they trudge home from the factories. Heavy rail cargo
                being unloaded by crane. Street-tough waifs running wild. A
                factory boss lashing a worker for an infraction. Squatters
                cooking a meal in the coal engine of an abandoned train car.
                <br />
                <strong>Streets:</strong> Multi-level, crowded with crates and
                discarded junk. Elevated rail lines.
                <br />
                <em>
                  Dunvil Way, Black Rock Road, Wright Street, Crane Street,
                  Forge Street.
                </em>
                <br />
                <strong>Buildings:</strong> Tall and narrow brick row houses
                with belching chimneys, metal-clad factories and warehouses,
                train cars converted into dwellings.
                <br />
                <strong>Factions</strong>
                <ul>
                  <li>1. The Gray Cloaks</li>
                  <li>2. The Lost</li>
                  <li>3. Sparkwrights</li>
                  <li>4. Ulf Ironborn</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="/.attachments/==image_0==-6b3eb2e3-3fcc-44bf-864a-71fdd5ec83c1.png"
                  alt="Coalridge district traits"
                />
                <br />
                <br />
                <em>
                  Because the factories of Coalridge operate around the clock,
                  there’s no ideal time for clandestine crime here, but foremen
                  are happy to be bribed to “take a break” or look the other
                  way.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Coalridge Locations</h1>
        <strong>
          <u>Brickston</u>
        </strong>
        : The most densely packed residential area in Duskwall. Brickston is a
        cramped jumble of multi-story brick row houses, stacked one atop the
        other. Many of the toughest scoundrels of the underworld hail from here,
        learning the harsh lessons of survival and gang life within its dark
        maze.
        <br />
        <br />
        <strong>
          <u>Coalridge Mine</u>
        </strong>
        : The site of the first permanent settlement at the river delta, the
        mine was originally built by the ancient Skov kingdom, who called it
        Doskovol—literally, “The Skov’s Coal.” The mine still operates over 1000
        years later, though demand for coal has dropped sharply as the Imperium
        adopts electroplasmic power more and more widely.
        <br />
        <br />
        <strong>
          <u>The Ironworks</u>
        </strong>
        : The Ironworks is a sprawling collection of massive industrial
        workhouses. Cruel foremen drive indentured laborers around the clock to
        keep up with the massive production demands to replace and refit
        leviathan hunter ships as well as the need for goods transported out to
        the Imperium at large.
        <br />
        <br />
        <strong>
          <u>The Old Rail Yard</u>
        </strong>
        : Before Gaddoc Station was built, this industrial rail yard was a
        center for commerce in the city. The Old Yard now serves only a couple
        heavy cargo trains daily, with many of its old rail cars rusted in place
        where they were abandoned.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Coalridge = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Coalridge;
